import Translation from 'components/Translation'

const AwardSection = () => {
    const images = [
        { title: '', src: '/images/rising_start.svg' },
        {
            title: '',
            src: '/images/capetra.svg',
        },
    ]

    return (
        <section className=" px-8 md:px-16 w-full wide:w-1920-p mb-8 md:mt-28 md:mb-12 mt-4  pt-0 lg:px-28 xl:px-44 2xl:px-80 container-fluid mx-auto ">
            <h1
                className="font-bold text-3xl leading-9	text-center uppercase circular_std	"
                style={{ color: '#2F4463' }}
            >
                <Translation content_key="landing.award_text" />
            </h1>
            <br></br>
            <div
                className="flex justify-center gap-14 flex-wrap mt-4 items-center"
                style={{ minHeight: '120px' }}
            >
                {images.map((data, index) => {
                    return (
                        <img
                            key={index}
                            src={data?.src}
                            alt="Not found"
                            className="w-40"
                        />
                    )
                })}
            </div>
        </section>
    )
}

export default AwardSection
